import { Component, computed, OnInit, signal, ViewChild, AfterViewInit } from '@angular/core';

import { Utils } from 'src/app/utils/utils';
import { AppComponent } from 'src/app/app.component';
import { MainComponent } from '../main/main.component';
import { environment } from 'src/environments/environment';
import * as xlsx from 'xlsx';

import { GeoUtils } from 'src/app/utils/geo-utils';
import { MapBounds, MapComponent, MapLatLng, MapPolygon } from 'movisat-maps';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { NzModalService } from 'ng-zorro-antd/modal';
import { SsoService } from 'src/app/services/sso/sso.service';
import { CuadriculaService } from 'src/app/services/cuadricula/cuadricula.service';

import { CuadriculaFormModel, CuadriculaListModel } from 'src/app/services/cuadricula/models/cuadricula.model';
import { MarcoGeograficoModel } from 'src/app/services/geographics/marco-geografico.model';
import { DateUtils } from 'src/app/utils/date-utils';
import { HeaderComponent } from '../header/header.component';
import { ZonaModel } from 'src/app/services/zones/models/zona.model';
import { ZonesService } from 'src/app/services/zones/zones.service';
import { WindowComponent } from 'movisat-common-gui';

const LADO_MINIMO_CUADRICULA = 200;

@Component({
  selector: 'app-cuadriculas',
  templateUrl: './cuadriculas.component.html',
  styleUrls: ['./cuadriculas.component.css']
})
export class CuadriculasComponent implements OnInit, AfterViewInit {
  public static _this: CuadriculasComponent;

  private componentRef = null;
  public theme = environment.tema;
  public langGrid = JqWidgets.getLocalization('es');
  protected isLoading = signal<boolean>(true);

  @ViewChild('myGrid') public myGrid: jqxGridComponent;
  @ViewChild('form') public form: WindowComponent;
  @ViewChild('header') public header: HeaderComponent;

  // grid
  public dataSource = {};
  public dataAdapter;
  public row: number;
  public visible = false;

  // mostrar formulario
  protected editorCuadricula: boolean = false;

  // instancia de la interfaz cuadricula
  public cuadricula: CuadriculaFormModel = {
    id: 0,
    nombre: "",
    empresa: 0,
    lado: LADO_MINIMO_CUADRICULA,
    zona: "",
    idZona: 0,
    descripcion: "",
    numeracionVisible: false,
    marco: null,
  };
  public cuadriculas: CuadriculaListModel[] = [];
  public modificando: boolean = false;
  protected LADO_MINIMO_CUADRICULA = LADO_MINIMO_CUADRICULA;

  // Medidas por defecto del marco en metros
  private marcoAncho = 10000;
  private marcoAlto = 10000;

  // map
  private map: MapComponent;
  private cuadroExterior: MapPolygon;
  public marcoCartoPolygon: MapPolygon;
  public polygonSquare: MapPolygon[] = [];
  private marco: MarcoGeograficoModel;

  // Selector zonas
  protected zonas: ZonaModel[] = [];
  public zonaFilter: string = '';
  public columns = [];

  public numVisibleFilter = null;
  protected isGuardando = signal<boolean>(false);
  protected disableGuardar = false;

  // Titulo de la ventana
  private countPartialResults = signal<number>(0);
  protected titleWindowSignal = computed(() => `${this.translate('Cuadriculas')} (${this.countPartialResults()})`);

  protected actions = [
    {type: "button", action:"salir", value: "", label: this.translate('Salir')}
  ];

  public actionButtonClicked(event): void {
    if(event.action === 'salir') {
      this.cerrarCuadriculas();
      return;
    }
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  public constructor(
    private modal: NzModalService,
    private cuadriculaService: CuadriculaService,
    private zonesService: ZonesService,
    private ssoService: SsoService) {
    CuadriculasComponent._this = this;
  }

  /**
  * Inicializa el componente
  */
  public init(componentRef: any): void {
    this.componentRef = componentRef;
  }

  public ngOnInit(): void {
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
    this.getZones();
    this.initGrid();
  }

  public setWindowTitle(): void {
    this.countPartialResults.set(this.myGrid.getrows().length);
  }

  public ngAfterViewInit(): void {
    this.map = MainComponent.getActiveMap();
    this.getCuadriculas()
  }

  private cerrarCuadriculas(): void {
    this.form.closeWindow();
  }

  //Carga de datos
  public initGrid(): void {
    this.columns = [
      {
        text: '',
        width: 100,
        columntype: 'text',
        sortable: false,
        editable: false,
        groupable: false,
        menu: false,
        rendered: (columnHeaderElement): void => {
          const buttonContainer1 = document.createElement('div');
          buttonContainer1.style.width = '100%';
          buttonContainer1.style.display = 'flex';
          buttonContainer1.style.justifyContent = 'center';

          buttonContainer1.id = `buttonContainerColumn_jqxButton`;
          columnHeaderElement[0].appendChild(buttonContainer1);
          const btnCrear = document.createElement('div');
          btnCrear.innerHTML =
            `<button class="button" style="height: 20px; width: 100%; padding: 0; margin: 0; cursor: pointer !important ; title="` +
            AppComponent.translate('Crear') + `"> <i style="font-size: 18px;" class="fa-solid fa-plus"></i></button>`;
          btnCrear.id = `buttonCrear_jqxButton`;
          buttonContainer1.appendChild(btnCrear);
          btnCrear.style.width = '50%'
          btnCrear.addEventListener('click', async () => {
            this.onCrearCuadricula();
          });
          return columnHeaderElement[0];
        },
        createwidget: (
          row: any,
          column: any,
          value: string,
          htmlElement: HTMLElement
        ): void => {
          this.initBtnColumn(row, column, value, htmlElement);
        },
        initwidget: (
          row: any,
          column: any,
          value: string,
          htmlElement: HTMLElement
        ): void => {
          this.initBtnColumn(row, column, value, htmlElement);
        },
      },
      { text: this.translate('Nombre'), datafield: 'Nombre', width: 'auto', editable: false, type: 'string', cellclassname: 'cellTooltip' },
      { text: this.translate('Descripcion'), datafield: 'Descripcion', width: 'auto', editable: false, type: 'string', cellclassname: 'cellTooltip' },
      { text: this.translate('Lado_celda'), datafield: 'Lado', width: '25%', filtertype: 'number', editable: false, cellclassname: 'cellTooltip' },
      { text: this.translate('Num_visible'), datafield: 'NumVisible', width: '25%', filtertype: 'checkedlist', editable: false, cellclassname: 'cellTooltip' },
      { text: this.translate('Zonas'), datafield: 'Zonas', width: '25%', filtertype: 'string', editable: false, cellclassname: 'cellTooltip' },
      { datafield: 'selec', hidden: true }
    ];

    let isFirstIteration = true;
    this.columns.forEach(column => {
      if (!isFirstIteration) {
        column.rendered = (element): void => { Utils.tooltiprenderer(element) };
      } else {
        isFirstIteration = false;
      }
    });
  }

  public async getCuadriculas(): Promise<void> {
    await this.cuadriculaService.getCuadriculas(this.zonas).subscribe(result => {
      this.cuadriculas = result;

      if (this.cuadriculas) {
        this.dataSource = {
          datatype: 'json',
          datafields: [
            { name: 'Id', type: 'string', map: 'id' },
            { name: 'Nombre', type: 'string', map: 'nombre' },
            { name: 'Descripcion', type: 'string', map: 'descripcion' },
            { name: 'Lado', type: 'number', map: 'lado' },
            { name: 'NumVisible', type: 'string', map: 'numeracionVisible' },
            { name: 'Zonas', type: 'string', map: 'zona' },
            { name: 'selec', map: 'selec' }
          ],
          localdata: this.cuadriculas,
        };
        this.dataAdapter = new jqx.dataAdapter(this.dataSource);
        this.myGrid.updatebounddata();
      }
      this.onBuscar();
    });
  }

  protected updatefilterconditions = (type: string, defaultconditions: any): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public async getZones(): Promise<void> {
    this.zonas = [];
    this.zonas.push(new ZonaModel());
    await this.zonesService.getZonas().then(
      res => {
        this.zonas = this.zonas.concat(res);

        this.getCuadriculas();

        this.isLoading.set(false);
      }
    );
  }

  onChangeNumVisible(event: any) {
    if(typeof event === 'boolean') {
      this.numVisibleFilter = event ? this.translate('SI') : this.translate('NO')
    }else {
      this.numVisibleFilter = null;
    }

    this.onBuscar();
  }

  onChangeZonaFiltro(event: any) {
    this.zonaFilter = event;

    this.onBuscar();
  }

  public filter(cellValue?: any, rowData?: any, dataField?: string, filterGroup?: any, defaultFilterResult?: boolean): any {
    const filterColumns = [
      'Nombre',
    ]

    return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
  }

  // Incializa la columna de botones
  async initBtnColumn(
    row: any,
    column: any,
    value: string,
    htmlElement: HTMLElement
  ) {
    let rowdata: any;
    if (isNaN(row)) {
      rowdata = row.bounddata;
    } else {
      rowdata = this.myGrid.getrowdata(row);
    }

    htmlElement.innerHTML = '';
    // Crea un contenedor para los botones
    const btnContainer = document.createElement('div');
    btnContainer.style.display = 'flex';
    btnContainer.style.justifyContent = 'flex-start';
    btnContainer.style.gap = '2px';
    btnContainer.style.padding = '2px';

    const btnEdit = document.createElement('div');
    btnEdit.innerHTML = `
      <button class="button" style="height: 23px; width: 30px; cursor: pointer;" title="`+ AppComponent.translate('Editar') + `">
        <i class="fa-solid fa-pen-to-square"></i>
      </button>
    `;
    btnEdit.id = `buttonEdit`;
    btnContainer.appendChild(btnEdit);

    btnEdit.addEventListener('click', async () => {
      const cuadricula = this.transformCuadriculaListToForm(this.cuadriculas.find(elem => elem.id == rowdata.Id));
      this.onEditarCuadricula(cuadricula);
    });

    // onVer
    const btnVer = document.createElement('div');
    btnVer.innerHTML = `
      <button class="button ver" style="height: 23px; width: 30px; cursor: pointer;" title="`+ AppComponent.translate('Ver') + `">
        <i class="fa-solid fa-eye"></i>
      </button>
    `;
    btnVer.id = `buttonVer`;
    btnContainer.appendChild(btnVer);

    // Crear el botón de Ocultar y agregarlo al contenedor, pero inicialmente estará oculto
    const btnOcultar = document.createElement('div');
    btnOcultar.innerHTML = `
      <button class="button ocultar" style="height: 23px; width: 30px; cursor: pointer; display: none;" title="`+ AppComponent.translate('Ocultar') + `">
        <i class="fa-solid fa-eye-slash"></i>
      </button>
    `;
    btnOcultar.id = `buttonOcultar`;
    btnContainer.appendChild(btnOcultar);

    // Agregar evento de click al botón Ver
    btnVer.addEventListener('click', async () => {
      this.cuadricula = this.transformCuadriculaListToForm(this.cuadriculas.find(elem => elem.id == rowdata.Id));
      this.onVerCuadricula();

      // Ocultar el botón Ver y mostrar el botón Ocultar
      btnVer.querySelector('button').style.display = 'none';
      btnOcultar.querySelector('button').style.display = 'inline-block';
    });

    // Agregar evento de click al botón Ocultar para revertir los cambios
    btnOcultar.addEventListener('click', () => {
      // Realizar las acciones necesarias para "ocultar" lo que se mostró con el botón Ver
      this.removePolygonSquare();


      // Mostrar el botón Ver y ocultar el botón Ocultar nuevamente
      btnVer.querySelector('button').style.display = 'inline-block';
      btnOcultar.querySelector('button').style.display = 'none';
    });

    const btnDelete = document.createElement('div');
    btnDelete.innerHTML = `
        <button class="button" style="height: 23px; width: 30px; cursor: pointer;" title="`+ AppComponent.translate('Borrar') + `">
          <i class="fa-solid fa-trash"></i>
        </button>
      `;
    btnDelete.id = `buttonDelete`;
    btnContainer.appendChild(btnDelete);

    btnDelete.addEventListener('click', async () => {
      const cuadricula = this.cuadriculas.find(elem => elem.id == rowdata.Id);
      this.modal.confirm({
        nzTitle: '<i>' + AppComponent.translate('ATENCION') + '</i>',
        nzContent: AppComponent.translate('Quiere_borrar_elemento') + ': ' + cuadricula.nombre + ' ?',
        nzCentered: true,
        nzCancelText: AppComponent.translate('CANCELAR'),
        nzOkText: AppComponent.translate('SI'),
        nzOnOk: async () => {
          if(btnOcultar.querySelector('button').style.display !== 'none'){
            this.removePolygonSquare();
          }
          await this.cuadriculaService.delCuadricula(cuadricula.id);
          MainComponent.getInstance().showSuccess('ATENCION', 'Registro_borrado', 2000);
          this.cuadriculas.splice(this.cuadriculas.indexOf(cuadricula), 1);
          this.myGrid.updatebounddata();
          this.row = null;
        }
      });
    });
    htmlElement.appendChild(btnContainer);
  }

  private transformCuadriculaListToForm(cuad: CuadriculaListModel): CuadriculaFormModel {
    return {
      id: cuad.id,
      nombre: cuad.nombre,
      empresa: cuad.empresa,
      lado: cuad.lado,
      zona: cuad.zona,
      idZona: cuad.idZona,
      descripcion: cuad.descripcion,
      numeracionVisible: cuad.numeracionVisible === this.translate('SI') ? true : false,
      marco: cuad.marco
    }
  }

  // obtener fila seleccionada
  protected onRowclick(event: any): void {
    this.row = event.args.row.bounddata.Id;
  }

  public onRowdoubleclick(event): void {
    const cuadricula = this.transformCuadriculaListToForm(this.cuadriculas.find(t => t.id === event.args.row.bounddata.Id))
    this.onEditarCuadricula(cuadricula);
  }

  //Crud form
  private onCrearCuadricula(): void {
    this.cuadricula = {
      id: 0,
      nombre: "",
      empresa: 0,
      lado: LADO_MINIMO_CUADRICULA,
      zona: "",
      idZona: 0,
      descripcion: "",
      numeracionVisible: false,
      marco: null,
    };
    this.editorCuadricula = true;
    this.modificando = false;
    this.marco = null;
    this.form.collapseWindow();
  }

  protected async onSaveCuadricula(cuadriculaToSave: CuadriculaFormModel): Promise<void> {
    // Comprobamos que los datos del formulario son correctos
    if (!(this.marco) || !this.controlForm()) {
      MainComponent.getInstance().showError('ATENCION', 'Pinte_cuadricula_mapa', 2000);
      return;
    }

    this.isGuardando.set(true);

    const cuadIndex = this.cuadriculas.findIndex(c => c.id == cuadriculaToSave.id)

    const cuadricula = await this.cuadriculaService.addCuadricula(cuadriculaToSave, this.zonas);

    if (cuadricula) {
      MainComponent.getInstance().showInfo(
        'ATENCION',
        'Registro_almacenado',
        2000
      );
      if(cuadIndex !== -1) {
        this.cuadriculas[cuadIndex] = cuadricula;
      }else {
        this.cuadriculas.push(cuadricula);
      }
      this.form.expandWindow();
      this.myGrid.updatebounddata('data');
      this.editorCuadricula = false;
    } else {
      MainComponent.getInstance().showError(
        'ATENCION',
        'Fallo_almacenar_info',
        2000
      );
    }
    this.isGuardando.set(false);
  }

  private onEditarCuadricula(cuadricula: CuadriculaFormModel): void {
    if(!cuadricula) {
      return;
    }
    this.cuadricula = cuadricula;

    this.editorCuadricula = true;
    this.modificando = true;
    // si no hay ninguna acción seleccionada, salgo
    if (!this.row) {
      MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
      return
    }

    // busco la acción en el array de acciones
    this.onCreateMarco();
    // Encuadro el mapa en el marco
    if(this.marco) {
      this.map.fitTo(this.marco.marco);
    }

    // Abro el formulario
    this.form.collapseWindow();
  }

  // Ver cuadrícula
  onVerCuadricula() {
    if (!this.row) {
      MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
      return;
    }
    else {
      this.modificando = true;
      this.onCreateMarco();
      this.map.setCenter(this.positionSquareCenter());
      if(this.marco) {
        this.map.fitTo(this.marco.marco);
      }
    }
  }

  renderSizeGrid() {
    Utils.renderSizeGrid(this.myGrid, 500)
  }

  // Obtenemos el centro de la cuadrícula si el marco ya está creado
  public positionSquareCenter(): MapLatLng {
    if (this.cuadricula?.marco) {
      const positionCenter: MapLatLng = new MapLatLng(this.cuadricula.marco.swCorner.lat + ((this.cuadricula.marco.neCorner.lat - this.cuadricula.marco.swCorner.lat) / 2),
        this.cuadricula.marco.swCorner.lng + ((this.cuadricula.marco.neCorner.lng - this.cuadricula.marco.swCorner.lng) / 2));
      return positionCenter
    }
  }

  //Control de los datos del formulario
  controlForm(): boolean {
    if (!this.cuadricula.nombre) {
      MainComponent.getInstance().showError('ATENCION', 'Introduzca_nombre', 2000);
      return false;
    } else if (this.cuadricula.lado < LADO_MINIMO_CUADRICULA || this.cuadricula.lado == undefined) {
      MainComponent.getInstance().showError('ATENCION', 'Minimo_cuadricula', 2000);
      return false;
    }
    return true;
  }

  // Configura el marco de 10 km²
  configLatLngMarco(position: MapLatLng): MapBounds {
    if (this.marco) {
      this.marcoAncho = GeoUtils.getDistance(this.marco.marco.swCorner.lat, this.marco.marco.swCorner.lng,
        this.marco.marco.swCorner.lat, this.marco.marco.neCorner.lng);
      this.marcoAlto = GeoUtils.getDistance(this.marco.marco.swCorner.lat, this.marco.marco.swCorner.lng,
        this.marco.marco.neCorner.lat, this.marco.marco.swCorner.lng);
    }
    return new MapBounds(GeoUtils.getNewLatLng(position, -(this.marcoAncho / 2), -(this.marcoAlto / 2)),
      GeoUtils.getNewLatLng(position, this.marcoAncho / 2, this.marcoAlto / 2));
  }

  // Crea el marco
  public onCreateMarco(): void {
    if(!this.cuadricula?.marco) {
      return;
    }
    this.marco = new MarcoGeograficoModel(this.cuadricula.marco);

    if (this.marcoCartoPolygon) {
      this.map.removePolygon(this.marcoCartoPolygon);
      this.marcoCartoPolygon = null;
    }

    this.marcoCartoPolygon = this.map.addPolygon({
      strokeColor: '#ff0000',
      strokeOpacity: 0.3,
      strokeWeight: 4,
      fillColor: '#000000',
      fillOpacity: 0
    });
    this.map.addPolygonPoint(this.marcoCartoPolygon, {
      dataModel: this,
      position: this.marco.marco.swCorner
    });
    this.map.addPolygonPoint(this.marcoCartoPolygon, {
      dataModel: this,
      position: new MapLatLng(this.marco.marco.neCorner.lat, this.marco.marco.swCorner.lng)
    });
    this.map.addPolygonPoint(this.marcoCartoPolygon, {
      dataModel: this,
      position: this.marco.marco.neCorner
    });
    this.map.addPolygonPoint(this.marcoCartoPolygon, {
      dataModel: this,
      position: new MapLatLng(this.marco.marco.swCorner.lat, this.marco.marco.neCorner.lng)
    });
    this.map.fitTo(this.marco.marco);
    this.addMarkersAtMarco(this.marco.marco, this.marcoCartoPolygon);
  }

  addMarkersAtMarco(position: MapBounds, polygon: MapPolygon) {
    this.removePolygonSquare();
    let lat1 = position.neCorner.lat;
    let lat2 = position.neCorner.lat;
    let lng1 = position.swCorner.lng;
    let lng2 = position.swCorner.lng;

    if (polygon) {
      this.map.removePolygon(polygon);
      polygon = null;
    }

    this.cuadroExterior = this.map.addPolygon({
      strokeColor: '#ff0000',
      strokeOpacity: 0.3,
      strokeWeight: 4,
      fillColor: '#000000',
      fillOpacity: 0
    });

    this.marcoCartoPolygon.points.forEach(point => {
      this.map.addPolygonPoint(this.cuadroExterior, {
        dataModel: this,
        content: '',
        position: point.point
      });
      if (point.point.lat < lat1) {
        lat1 = point.point.lat;
      }
      if (point.point.lng < lng1) {
        lng1 = point.point.lng;
      }
      if (point.point.lat > lat2) {
        lat2 = point.point.lat;
      }
      if (point.point.lng > lng2) {
        lng2 = point.point.lng;
      }
    });

    this.getSquareBounds(new MapLatLng(lat1, lng1), new MapLatLng(lat2, lng2));
  }

  // Elimina los polígonos de la cuadrícula
  removePolygonSquare() {
    this.polygonSquare.forEach(polygon => this.map.removePolygon(polygon));
    this.polygonSquare = [];

    if (this.cuadroExterior) {
      this.map.removePolygon(this.cuadroExterior);
      this.cuadroExterior = null;
    }
  }

  private async getSquareBounds(markerSw: MapLatLng, markerNe: MapLatLng): Promise<void> {
    // Cojo las esquinas del marco
    const swCorner = this.modificando ? markerSw : this.marco.marco.swCorner;
    const neCorner = this.modificando ? markerNe : this.marco.marco.neCorner;
    // Calculo las medidas del marco
    const marcoAncho = GeoUtils.getDistance(swCorner.lat, swCorner.lng, swCorner.lat,
      swCorner.lng + (neCorner.lng - swCorner.lng));
    const marcoAlto = GeoUtils.getDistance(swCorner.lat, swCorner.lng, swCorner.lat +
      (neCorner.lat - swCorner.lat), swCorner.lng);
    // Calculo el número filas que cogen dentro del marco
    const numColumnas = Math.floor(marcoAncho / this.cuadricula.lado);
    // Calculo el número columnas que cogen dentro del marco
    const numFilas = Math.floor(marcoAlto / this.cuadricula.lado);
    if (numFilas > 0 && numColumnas > 0) {
      this.disableGuardar = false;
    } else {
      MainComponent.getInstance().showWarning('ATENCION', 'Tamaño_cuadricula', 2000);
      this.disableGuardar = true;
    }
  }

  onClose() {
    CuadriculasComponent._this = null;
  }

  ngOnDestroy() {
    if (this.marcoCartoPolygon) {
      this.map.removePolygon(this.marcoCartoPolygon);
      this.marcoCartoPolygon = null;
    }
    if (this.cuadroExterior) {
      this.map.removePolygon(this.cuadroExterior);
      this.cuadroExterior = null;
    }
    this.removePolygonSquare();
  }

  protected onCloseForm(): void {
    this.editorCuadricula = false;
    this.form.expandWindow();

    if (this.marcoCartoPolygon) {
      this.map.removePolygon(this.marcoCartoPolygon);
      this.marcoCartoPolygon = null;
    }

    this.removePolygonSquare();
  }

  onFilter() {
    this.setWindowTitle();
  }

  onBindingComplete() {
    this.setWindowTitle();
  }

  eventFilter() {
    this.header.searchInput['nativeElement'].value = '';
    this.getCuadriculas();
  }

  eventResetFilter() {
    this.myGrid.clearfilters();
    this.header.searchInput['nativeElement'].value = '';
    this.header.numVisible.val(null);
    this.header.dropZonas.selectIndex(0);
    this.onBuscar();
  }

  protected onBuscar(): void {
    let filtervalue = '';
    if (this.header.searchInput['nativeElement'].value.length >= 3) {
      filtervalue = this.header.searchInput['nativeElement'].value.toUpperCase();
    } else {
      filtervalue = '';
    }

    this.cuadriculas.forEach(cuad => {
      const completeText = [
        cuad?.nombre,
        cuad?.descripcion,
        cuad?.lado + '',
      ].filter(t => t).join(' ');

      if (
        (
          completeText.compareWith(filtervalue)
        ) &&
        (
          this.zonaFilter !== '' ?
            cuad.zona !== null &&
            cuad.zona.compareWith(this.zonaFilter) :
            true
        ) &&
        (
          this.numVisibleFilter !== null ?
          this.numVisibleFilter === cuad.numeracionVisible :
          true
        )
      ) {
        cuad['selec'] = 'selec';
      } else {
        cuad['selec'] = '';
      }
    });

    // Compruebo si ya he creado el filtro "selec" anteriormente
    const filters = this.myGrid.getfilterinformation();
    if (filters.find(s => s.datafield === 'selec') === undefined) {
      const filtergroup = new jqx.filter();
      filtergroup.operator = 'and';
      filtergroup.addfilter(0, filtergroup.createfilter('stringfilter', 'selec', 'equal'));
      this.myGrid.addfilter('selec', filtergroup);
    }
    this.myGrid.applyfilters();
    this.myGrid.updatebounddata('data');
  }

  protected onExportar(): void {
    if (this.myGrid.getrows().length === 0) {
      return MainComponent.getInstance().showWarning('ATENCION', this.translate('No_existen_datos'), 2000);
    }

    const data = this.myGrid.getrows();

    const transformedData = data.map((row: any) => {
      const { uid, visibleindex, dataindex, selec, uniqueid, boundindex, Id, ...filteredRow } = row;
      return {
        ...filteredRow
      }
    });

    const ws: xlsx.WorkSheet = xlsx.utils.json_to_sheet(transformedData);
    this.generateAutofilterHeader(ws);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Hoja1');
    xlsx.writeFile(wb, DateUtils.formatDateAMDhms(new Date()) + '_' + this.translate('Zonas') + '.xlsx');
  }

  private generateAutofilterHeader(sheet): void {
    // Añade filtro a todas las casillas.
    sheet['!autofilter'] = { ref: sheet['!ref'] };
  }
}
